const setGlobalData = data => {
  if (!window.globalData) {
    window.globalData = {};
  }
  window.globalData = {...window.globalData, ...data};
}

const getCookie = (cookiename) => {
  var cookiestring=RegExp(cookiename+"=[^;]+").exec(document.cookie);
  return decodeURIComponent(!!cookiestring ? cookiestring.toString().replace(/^[^=]+./,"") : "");
}

const getGlobalData = key => {
  if (!window.globalData) {
    window.globalData = {};
  }
  if (!window.globalData[key]) {
    var data = {};
    if (key==='token') {      
      data = getCookie('token');
      if (data) {
        setGlobalData({token:data});
      }
      return data;
    }
    if (key==='info') {
      data = JSON.parse(localStorage.getItem('info'));
      setGlobalData({info:data});
      return data;
    }
    return {}
  }
  return window.globalData[key];
}

const getInfoValue = key => {
  const info = getGlobalData('info');
  if(!info[key]) {
    return false;
  }
  return info[key];
}

const imgResize = (url, max) => {
  var w = window.innerWidth;
  if (w > max) {
    w = max;
  }
  w = Math.ceil(w/200)*200;
  if (w > 400) {
    url = url.replace('/400/', '/'+w+'/');
  }
  //console.log([w, url])  ;
  return url;
}

const tagColors = ['#2d5e99','#875d9d','#c84d4f','#fcce5a','#d4df5c','#52ad5e'];

export { setGlobalData, getGlobalData, getInfoValue, imgResize, tagColors };
